import styled from 'styled-components';
import { BigText } from '../../../../../ui';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 24px;
`;

export const TitleContainer = styled.div`
  padding: 16px 0;
`;

export const TitleLabel = styled(BigText)``;

export const ItemsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 8px 0;

  & > div {
    flex: 250px;
    margin: 8px;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const Item = styled.div`
  height: 150px;
`;
